<template>
  <footer>
    <template v-if="user && user.portal == 'GLAD'">
      <div class="bg-light py-5">
        <b-container>
          <b-row>
            <b-col>
              <b-row>
                <b-col>
                  <a
                    href="https://gladswitzerland.ch/"
                    class="mt-2"
                    style="display: block;"
                  >
                    <img
                      src="../../assets/glad_logo.png"
                      style="max-width: 220px;"
                    />
                  </a>
                </b-col>
              </b-row>
              <b-row class="mt-5">
                <b-col>
                  <b>{{ $t('FOOTER_contact') }}</b>
                  <br />
                  <a href="mailTo:gladschweiz.gesundheit@zhaw.ch"
                    >gladschweiz.gesundheit@zhaw.ch</a
                  >
                </b-col>
              </b-row>
              <b-row class="mt-5">
                <b-col>
                  Rheumafit&copy;, eine Platform von
                  <br />
                  <a
                    href="https://www.bechterew.ch"
                    class="mt-2"
                    style="display: block;"
                  >
                    <img
                      v-if="language === 'fr'"
                      src="../../assets/Bechterew_Logo_f_rgb2.svg"
                      style="width: 75%; max-width: 180px;"
                    />
                    <img
                      v-if="language === 'it'"
                      src="../../assets/Bechterew_Logo_i_rgb.svg"
                      style="width: 75%; max-width: 180px;"
                    />
                    <img
                      v-if="language === 'de'"
                      src="../../assets/Bechterew_Logo_d_rgb2.svg"
                      style="width: 75%; max-width: 180px;"
                    />
                    <img
                      v-if="language === 'en'"
                      src="../../assets/Bechterew_Logo_e_rgb.svg"
                      style="width: 75%; max-width: 180px;"
                    />
                    <img
                      v-if="language === 'bg'"
                      src="../../assets/Bechterew_Logo_e_rgb.svg"
                      style="width: 75%; max-width: 180px;"
                    />
                  </a>
                </b-col>
              </b-row>
            </b-col>
            <b-col>
              <b-row class="mt-3">
                <b-col>
                  <b>{{ $t('FOOTER_experts') }}</b>
                  <br />IG GLA:D Schweiz
                </b-col>
              </b-row>
              <b-row class="mt-5">
                <b-col>
                  <b>{{ $t('FOOTER_physiotherapist') }}</b>
                  <br />Nicole Steinmann-Gartenmann
                </b-col>
              </b-row>
            </b-col>
            <b-col v-if="!['xs', 'sm'].includes($mq)">
              <b>{{ $t('FOOTER_partner') }}</b>
              <br />
              <div class="my-2">
                <a href="https://www.rheumaliga.ch">
                  <img
                    v-if="language === 'fr'"
                    src="../../assets/Rheumaliga Schweiz_f_Grau.svg"
                    style="width: 70%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'de'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'it'"
                    src="../../assets/Rheumaliga Schweiz_i_Grau.svg"
                    style="width: 70%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'en'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'bg'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%; max-width: 120px;"
                  />
                </a>
              </div>
              <br />
              <a href="http://www.zhaw.ch">
                <img
                  src="../../assets/zhaw_gh_grau_cmyk_d.svg"
                  style="width: 70%; max-width: 120px;"
                />
              </a>
              <br />
              <br />
              <b>{{ $t('FOOTER_support') }}</b>
              <br />
              <a
                href="https://gesundheitsfoerderung.ch/"
                class="mt-2"
                style="display: block;"
              >
                <img
                  src="../../assets/gfs.png"
                  style="width: 100%; max-width: 220px;"
                />
              </a>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </template>
    <template v-else>
      <div class="bg-light py-5">
        <div class="container">
          <div class="row">
            <div class="col">
              <a href="https://www.bechterew.ch">
                <img
                  v-if="language === 'fr'"
                  src="../../assets/Bechterew_Logo_f_rgb2.svg"
                  style="width: 75%;%; max-width: 180px;"
                />
                <img
                  v-if="language === 'it'"
                  src="../../assets/Bechterew_Logo_i_rgb.svg"
                  style="width: 75%;%; max-width: 180px;"
                />
                <img
                  v-if="language === 'de'"
                  src="../../assets/Bechterew_Logo_d_rgb2.svg"
                  style="width: 75%;%; max-width: 180px;"
                />
                <img
                  v-if="language === 'en'"
                  src="../../assets/Bechterew_Logo_e_rgb.svg"
                  style="width: 75%;%; max-width: 180px;"
                />
                <img
                  v-if="language === 'bg'"
                  src="../../assets/Bechterew_Logo_e_rgb.svg"
                  style="width: 75%;%; max-width: 180px;"
                />
              </a>
            </div>
            <div class="col-6 col-sm-5">
              <b>{{ $t('FOOTER_experts') }}</b>
              <br />Prof. Dr. Karin Niedermann <br />Dr. Peter Oesch
              <br />Olivia Steinbaum
            </div>
            <div v-if="!['xs', 'sm'].includes($mq)" class="col-3">
              <b>{{ $t('FOOTER_partner') }}</b>
              <br />
              <div class="my-2">
                <a href="https://www.rheumaliga.ch">
                  <img
                    v-if="language === 'fr'"
                    src="../../assets/Rheumaliga Schweiz_f_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'de'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'it'"
                    src="../../assets/Rheumaliga Schweiz_i_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'en'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'bg'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                </a>
              </div>
              <br />
              <a href="http://www.zhaw.ch">
                <img
                  src="../../assets/zhaw_gh_grau_cmyk_d.svg"
                  style="width: 70%;%; max-width: 120px;"
                />
              </a>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col">
              <b>{{ $t('FOOTER_contact') }}</b>
              <br />
              <a href="mailTo:mail@bechterew.ch">mail@bechterew.ch</a>
              <br />+41 (0)44 272 78 66
            </div>
            <div class="col-6 col-sm-5">
              <b>{{ $t('FOOTER_physiotherapists') }}</b>
              <br />Susanne Leemann <br />Matthias von Rohr <br />Melanie Hempel
            </div>
            <div v-if="!['xs', 'sm'].includes($mq)" class="col-3">
              <b>{{ $t('FOOTER_support') }}</b>
              <br />
              <a
                href="https://gesundheitsfoerderung.ch/"
                class="mt-2"
                style="display: block;"
              >
                <img
                  src="../../assets/gfch_grey.png"
                  style="width: 100%; max-width: 220px;"
                />
              </a>
              <br />
              <a
                href="https://gesundheitsfoerderung.ch/"
                class="mt-2"
                style="display: block;"
              >
                <img
                  src="../../assets/mlr.svg"
                  style="width: 80%; max-width: 160px;"
                />
              </a>
            </div>
          </div>
          <div v-if="!['xs', 'sm'].includes($mq)" class="row pt-5">
            <div class="col">
              <b>{{ $t('FOOTER_social') }}</b>
              <br />
              <h3 class="d-inline mr-2 link">
                <a
                  href="https://www.facebook.com/bechterew.ch/"
                  class="fa fa-facebook-official text-secondary"
                />
              </h3>
              <h3 class="d-inline mr-2 link">
                <a
                  href="https://blog.bechterew.ch/"
                  class="fa fa-comments text-secondary"
                />
              </h3>
              <h3 class="d-inline mr-2 link">
                <a
                  href="https://www.youtube.com/user/bechterewschweiz"
                  class="fa fa-youtube-play text-secondary"
                />
              </h3>
            </div>
          </div>
          <div v-else class="row mt-4">
            <div class="col-6 col-sm-7">
              <b>{{ $t('FOOTER_support') }}</b>
              <br />
              <a
                href="https://gesundheitsfoerderung.ch/"
                class="mt-2"
                style="display: block;"
              >
                <img
                  src="../../assets/gfch_grey.png"
                  style="width: 100%; max-width: 220px;"
                />
              </a>
              <br />
              <a
                href="https://gesundheitsfoerderung.ch/"
                class="mt-2"
                style="display: block;"
              >
                <img
                  src="../../assets/mlr.svg"
                  style="width: 80%; max-width: 160px;"
                />
              </a>
            </div>
            <div class="col-6 col-sm-5">
              <b>{{ $t('FOOTER_partner') }}</b>
              <div class="my-2">
                <a href="https://www.rheumaliga.ch">
                  <img
                    v-if="language === 'fr'"
                    src="../../assets/Rheumaliga Schweiz_f_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'de'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'it'"
                    src="../../assets/Rheumaliga Schweiz_i_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'en'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                  <img
                    v-if="language === 'bg'"
                    src="../../assets/Rheumaliga Schweiz_d_Grau.svg"
                    style="width: 70%;%; max-width: 120px;"
                  />
                </a>
              </div>
              <a href="http://www.zhaw.ch">
                <img
                  src="../../assets/zhaw_gh_grau_cmyk_d.svg"
                  style="width: 70%;%; max-width: 120px;"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>
    <div class="container">
      <div class="row pt-2 pb-1" style="font-size: 12px; max-height: 24px;">
        <div class="col text-left">
          <p>
            <MadeWithLove />
          </p>
        </div>
        <b-col md="auto" class="text-center text-light2">
          <p v-b-tooltip.top="`version: ${version} - ${gitSHA}`">
            <b>{{ version }}</b>
          </p>
        </b-col>
        <b-col class="text-right">
          <feature name="faq" tag="span">
            <b-link :to="{ name: 'faq' }" class="pr-3">FAQ</b-link>
          </feature>
          <b-link :to="{ name: 'about' }" class="pr-3">{{
            $t('about')
          }}</b-link>
          <LinkLegal target />
        </b-col>
      </div>
    </div>
  </footer>
</template>

<script>
import config from '@/config';
import { mapState, mapGetters } from 'vuex';
import MadeWithLove from '@/elements/MadeWithLove';
import LinkLegal from '@/elements/links/Legal';

export default {
  name: 'footer-navigation',
  components: { MadeWithLove, LinkLegal },
  computed: {
    version: () => config.version,
    gitSHA: () => config.gitSHA,
    ...mapState(['language']),
    ...mapGetters(['user']),
  },
};
</script>

<style scoped>
.link :hover {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/FooterNavigation/desktop.vue